/**
 * Supabase REST API — turnuva ve maç kayıtları için (fetch ile, SDK yok).
 * .env: REACT_APP_SUPABASE_URL ve REACT_APP_SUPABASE_ANON_KEY
 */

const url = process.env.REACT_APP_SUPABASE_URL
const key = process.env.REACT_APP_SUPABASE_ANON_KEY

export function isSupabaseConfigured() {
    return !!(url && key)
}

/**
 * Supabase Postgres REST: GET isteği.
 * @param {string} table - Tablo adı (tournaments, matches)
 * @param {object} opts - { select, order, eq, ilike }
 * @returns {Promise<{ data: array, error: object | null }>}
 */
function supabaseGet(table, opts) {
    if (!url || !key) return Promise.resolve({ data: null, error: { message: 'Sunucu yapılandırılmamış' } })

    const base = url.replace(/\/$/, '') + '/rest/v1/'
    const params = new URLSearchParams()
    if (opts.select) params.set('select', opts.select)
    if (opts.order) params.set('order', opts.order)
    if (opts.eq) {
        Object.keys(opts.eq).forEach(k => params.set(k, 'eq.' + opts.eq[k]))
    }
    if (opts.ilike) {
        Object.keys(opts.ilike).forEach(k => params.set(k, 'ilike.' + opts.ilike[k]))
    }

    const query = params.toString()
    const fullUrl = base + encodeURIComponent(table) + (query ? '?' + query : '')

    return fetch(fullUrl, {
        method: 'GET',
        headers: {
            apikey: key,
            Authorization: 'Bearer ' + key,
            'Content-Type': 'application/json',
        },
    })
        .then(res => {
            if (!res.ok) return res.json().then(j => ({ data: null, error: j || { message: res.statusText } }))
            return res.json().then(data => ({ data, error: null }))
        })
        .catch(err => ({ data: null, error: { message: err.message } }))
}

export { supabaseGet }



// WEBPACK FOOTER //
// ./src/lib/supabase.js